/**
 * React Component for the Game Centre Statistics page.
 * WARNING - Stats page not complete
 */
import React from "react";
import Statistics from "../core/Statistics";
import {useQuery} from "@tanstack/react-query";
import Loading from "../core/Loading";
import {allSeasons} from "../utils/time";

const Component = (offset) => {
  const { isLoading, error, data} = useQuery({
    staleTime: Infinity,
    queryKey: ['teams'],
    queryFn: () =>
        fetch(`${process.env.REACT_APP_BUIHA_API_URL}/club/allteams/`).then((res) =>
            res.json(),
        ),
  });

  if (isLoading)
    return (
      <Loading />
    );


  if (error) return 'An error has occurred: ' + error.message;

  data && data.sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <Statistics
      mode={'all'}
      teams={data}
      id={null}
      season_offset={offset.offset}
      seasons={allSeasons()}
    />
  );
}

export default Component;